import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-391bab78"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["src"];

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "platform-intro",
  style: {
    "font-weight": "400",
    "font-size": "14px",
    "color": "#4E5969"
  }
}, [/*#__PURE__*/_createTextVNode(" 针对教学资源散布、数据孤岛明显、教学模式传统、评价模式不适用等问题，学校于2020年开始着手创建成工智学数智化教育教学平台（简称\"成工智学\"），统筹构筑应用型人才智慧教学和管理的全新生态。作为成都工业学院数字化转型的核心载体，\"成工智学\"锚定\"智慧管理、智慧教学、智慧评价\"3个目标，立足\"构建智慧校园治理体系、优化数字教学资源和教学模式、数智赋能教学评价体系\"3个维度，赋能\"教、学、备、管、考、评、研\"7大教育教学场景。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 平台创新构建三大核心功能：一是采用国产信创技术搭建统一平台，实现多校区智慧教室联动与跨系统数据融合，依托DeepSeek大模型开发长期记忆画像系统，构建课程专属知识图谱；二是教学模式革新，支撑全校千门课程常态化混合式教学，实现\"AI课代表智能答疑+AI教研自动备课+AI助管学情分析\"全流程赋能；三是智能管理创新，实现\"自主架构+自有模型+AI工具\"三轨发展，依托大模型开发20余种校本工具，覆盖课前课中课后全流程，实现教学过程的动态监测与智能诊断，推动全校教学数智化转型与质量闭环管理。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 平台现已形成丰富的课程和专业教学资源，实现全校课程数字化运行，建设国家级一流课程1门，省级一流课程5门，课程资源累计服务省内外高校649校次、129.68万人次选课。已开发42门AI智慧课程，建成机械电子工程等3个专业知识图谱，引入跨校共享课680门次，云端资源库累计上传38364个，合计占用2845.8GB云存储空间，沉淀形成13.25万项教学资源。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 截止2025年5月，\"成工智学\"的建设与实践获2024年四川省数字校园应用场景优秀案例、2024年教育部\"智慧教育示范区\"智慧教育优秀案例，入选2025年教育部教师工作司《新时代教师队伍建设改革工作先进案例名单》，成为数字化赋能教师发展领域7个先进案例之一。平台建设经验被\"新华网\"\"中国网\"《四川日报》等国家级、省级等媒体先后报道，吸引8所省内外高校实地考察交流，成都工业学院\"数字成工\"初步形成辐射效应。 ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "intro-footer",
  style: {
    "text-align": "right",
    "font-weight": "500",
    "font-size": "12px",
    "color": "#86909C",
    "padding": "15px"
  }
}, " （文中涉及数据截至统计时间为2025年5月23日） ")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");

  const _component_el_carousel = _resolveComponent("el-carousel");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sec_banner", $data.bannerList.length <= 1 ? 'hiddenSlides' : ''])
  }, [$data.bannerList.length > 0 ? (_openBlock(), _createBlock(_component_el_carousel, {
    key: 0,
    arrow: ($data.bannerList && $data.bannerList.length) > 1 ? 'hover' : 'never',
    height: "80vh"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannerList, ({
      id,
      file_url,
      target_type,
      target_url
    }) => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        class: _normalizeClass(["banner-item", {
          'click-banner': id === $data.firstBannerId
        }]),
        key: id
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "banner-wrapper",
          onClick: $event => $options.getBannerUrl(target_type, target_url, id)
        }, [_createElementVNode("img", {
          class: "banner-img",
          src: file_url || require('../../../assets/images/banner .png')
        }, null, 8, _hoisted_2)], 8, _hoisted_1)]),
        _: 2
      }, 1032, ["class"]);
    }), 128))]),
    _: 1
  }, 8, ["arrow"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: $data.showPopup,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.showPopup = $event),
    title: "平台简介",
    width: "50%",
    "close-on-click-modal": false,
    class: "custom-popup",
    "append-to-body": ""
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }, 8, ["modelValue"])], 2);
}